export { default as default } from "./createWorkerFunctionInNode.js";
